import { Button } from "common/components/ui/Button";
import {
  DialogClose,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  DrawerClose,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import SeatPurchaseImage from "assets/images/seat-purchase.png";

interface SeatPurchaseProps {
  additionalSeatsCount: number;
  onNext: () => void;
}

export default function SeatPurchase({
  additionalSeatsCount,
  onNext,
}: SeatPurchaseProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { subscription_status } = useSelectedWorkspaceContext();

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;
  const Close = isDesktop ? DialogClose : DrawerClose;

  const isFreeTrial = subscription_status === "in_trial";
  const isMultiple = additionalSeatsCount > 1;

  let title: string;
  let description: string;
  let buttonText: string;

  if (isFreeTrial) {
    title = "Add a Trial seat to use LinkedIn Outreach";
    description =
      "This feature requires a LinkedIn Outreach seat. You will not be charged for any seats until your trial expires";
    buttonText = "Add a seat";
  } else if (isMultiple) {
    title = "Not enough seats";
    description = `You do not have enough unassigned seats for all selected accounts. You must purchase ${additionalSeatsCount} more seats to complete this action`;
    buttonText = "Get more seats";
  } else {
    title = "You need to purchase a seat to use LinkedIn Outreach";
    description =
      "You do not have available seats at this time. You will need to purchase a seat to use this feature";
    buttonText = "Purchase a seat";
  }

  return (
    <>
      <img
        src={SeatPurchaseImage}
        width={364}
        height={254}
        className="mx-auto mb-4"
        alt=""
      />

      <Title>{title}</Title>

      <Description className="mb-8">{description}</Description>

      <div className="flex justify-between lg:grid lg:grid-cols-2 gap-x-2.5">
        <Close asChild>
          <Button variant="secondary-black">Cancel</Button>
        </Close>

        <Button variant="gradient" onClick={onNext}>
          {buttonText}
        </Button>
      </div>
    </>
  );
}
